import * as _4 from 'lodash4';

export class APMmDevReqTemplateSlot {
  id: number;
  nk: string;
  title: string;
  credits: string;
  has_prereq: boolean;
  has_coreq: boolean;

  constructor(slot: APMmDevReqTemplateSlot) {
    _4.merge(this, { slotType: 'DEV_REQ_COURSE' }, slot);
  }
  static build(slot: APMmDevReqTemplateSlot): APMmDevReqTemplateSlot {
    return new APMmDevReqTemplateSlot(slot);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/ap_multi_template_dev_req_slot_builder.ts